<script>
  export default {
    data() {
      return {}
    },
  }
</script>

<template>
  <div class="section SectionSupport">
    <div class="container">
      <h2 class="Home-title color-primary">
        零壹科技線上報修服務
      </h2>
      <p class="color-gray-6">
        零壹科技提供公開透明化的線上報修服務，隨時為您提供最佳的維修服務與協助，讓您對於產品的使用毫無後顧之憂
      </p>
      <div class="text-center mt-5">
        <BaseButton
          class="isStylePrimary isRadius isCol4"
          :to="{ name: 'repair' }"
        >
          報修 / 查詢
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  .SectionSupport {
    padding: 6.25rem 0;
    background: $color-gray-2;
    // display: flex;
    // align-items: center;
    // justify-content: center;
    // height: 775px;
    // background-repeat: no-repeat;
    // background-position: center;
    // background-size: cover;

    @include max-md {
      height: auto;
    }

    p {
      max-width: 648px;
      margin-right: auto;
      margin-left: auto;
      line-height: 1.75;
      text-align: center;
    }


    @media (min-width: 1921px) {
      // background-size: cover;
      // height: 900px;
    }

    .HomeSection__btn-wrapper {
      margin-top: 70px;
    }
  }
</style>
